exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.background-size80[data-v-fc0b077e] {\n  margin-top: 4px;\n}\n.p[data-v-fc0b077e] {\n  font-family: 'Roboto, sans-serif';\n  font-size: 13pt;\n  white-space: 'break-spaces';\n}\n.txtBtn[data-v-fc0b077e] {\n  font-display: 'Roboto, sans-serif';\n}\n@media (max-width: 780px) {\n.boxBtn[data-v-fc0b077e] {\n    -webkit-box-shadow: rgb(4 4 4) 0px 0px 0px 0px !important;\n            box-shadow: rgb(4 4 4) 0px 0px 0px 0px !important;\n}\n}\n", ""]);

// exports
